// removed by extract-text-webpack-plugin
module.exports = {"consent-html":"consent-html__mS80l"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/ConsentDetail.scss
// module id = VRqK
// module chunks = 1